// Minimal type wrapper around the Telegram WebApp global.
// Spec: https://core.telegram.org/bots/webapps

export interface TgUser {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  language_code?: string;
}

export interface TelegramWebApp {
  initData: string;
  initDataUnsafe: { user?: TgUser; auth_date?: number; query_id?: string };
  ready(): void;
  expand(): void;
  close(): void;
  colorScheme: "light" | "dark";
  themeParams: Record<string, string>;
  BackButton: {
    show(): void;
    hide(): void;
    onClick(cb: () => void): void;
    offClick(cb: () => void): void;
  };
  HapticFeedback: {
    impactOccurred(style: "light" | "medium" | "heavy" | "rigid" | "soft"): void;
    notificationOccurred(type: "error" | "success" | "warning"): void;
    selectionChanged?(): void;
  };
  showAlert(message: string): void;
  showConfirm(message: string, cb: (ok: boolean) => void): void;
  // Chrome colors — present on newer clients; used to match the light/dark theme.
  setBackgroundColor?(color: string): void;
  setHeaderColor?(color: string): void;
  setBottomBarColor?(color: string): void;
  openLink?(url: string, options?: { try_instant_view?: boolean }): void;
  openTelegramLink?(url: string): void;
}

/** Open Telegram's "share to chat" dialog for a one-time invite link. */
export function shareInvite(url: string, text: string): boolean {
  const share = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
  const t = tg();
  if (t?.openTelegramLink) {
    t.openTelegramLink(share);
    return true;
  }
  try {
    window.open(share, "_blank");
    return true;
  } catch {
    return false;
  }
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export function tg(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function initData(): string {
  return tg()?.initData ?? "";
}

export function tgUser(): TgUser | null {
  return tg()?.initDataUnsafe?.user ?? null;
}

export function isInsideTelegram(): boolean {
  return !!tg()?.initData;
}
